import {useMultiStyleConfig} from '@chakra-ui/react';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import type {MultipartStyles} from '../types';

const ANATOMY = [`container`, `header`] as const;

const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(ANATOMY);

const baseStyle = definePartsStyle({
  container: {
    boxShadow: `none`,
    bgColor: `background.primary`,
    display: `flex`,
    flexDirection: `column`,
    alignItems: `stretch`,
    borderRadius: `radius-100`,
    p: `space-200`,
    gap: `space-200`,
  },
  header: {
    display: `flex`,
    alignItems: `center`,
    flexDirection: `row`,
    justifyContent: `space-between`,
    gap: `space-100`,
  },
});

export const formSectionTheme = defineMultiStyleConfig({
  baseStyle,
});

export const useFormSectionStyleConfig = (props?: Parameters<typeof useMultiStyleConfig>[1]) =>
  useMultiStyleConfig(`FormSection`, props ?? {}) as MultipartStyles<(typeof ANATOMY)[number]>;
